module.exports = __webpack_public_path__ + "img/logo_powershell.a0c39cd3.svg";